import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { routes } from 'config';
import { Container } from 'styles';
// TODO - refactor these modules
import { ContactSupport } from 'components/modules/contact-support';
import { RecsModule } from '../components/recs';
import { UsageSummary } from '../components/usage-summary';
import { WindProject } from '../components/wind-project';
import { UsageGraph as UsageGraphModule } from '../components/usage-graph';
import { UtilityConnectCta } from '../components/utility-connect-cta';
import { UsageAnalysis } from '../components/usage-analysis';
// ------------------------
import { EnergyAnalysis } from '../secondary/energy-analysis';
import { EnergyDetails } from '../secondary/energy-details';
import { Impact } from '../secondary/impact';
import { WindDetails } from '../secondary/wind-details';
import { Recs } from '../secondary/recs';
import { Layout } from '../layout';

const Additional = () => (
  <>
    <UtilityConnectCta />
    <Container>
      <ContactSupport />
    </Container>
  </>
);

const Dashboard = () => (
  <Layout
    testId="usage-active"
    additional={<Additional />}
    breakdown={<UsageAnalysis />}
    graph={<UsageGraphModule />}
    project={<WindProject />}
    recs={<RecsModule />}
    summary={<UsageSummary />}
  />
);

export const Active = () => {
  const routeTemplates = routes();
  return (
    <Switch>
      <Route path={routeTemplates.energyDetails} component={EnergyDetails} />
      <Route path={routeTemplates.energyAnalysis} component={EnergyAnalysis} />
      <Route path={routeTemplates.impact} component={Impact} />
      <Route path={routeTemplates.projects} component={WindDetails} />
      <Route path={routeTemplates.recs} component={Recs} />
      <Route path={routeTemplates.usage} component={Dashboard} />
      <Redirect to={routeTemplates.usage} />
    </Switch>
  );
};
